/* eslint-disable */
import {
  bridge, build, canIUse, get, getEnvInfo, goTo, is, isLogin, locate, login, query, setOmegaAttrs, setShare as webxSetShare, trackEvent, utils, weixinmpReady, xenv
} from '@didi/webx-js'
import store, {
  pageStyle
} from './store'

export function initLogin(option = {}) {
  if (store.getters.userInfo.token) return Promise.resolve({
    token: store.getters.userInfo.token
  })
  return isLogin().catch(e => {
    if (option.needLogin) {
      if (__mpx_mode__ === 'web') {
        if (option.wxOauth && xenv() === 'weixin' && (query().state !== window.sessionStorage.getItem('wxOauth'))) {
          const appidMap = {
            kf: 'wxced89f4c09309b4f', // 花小猪打车乘客
            didi: 'wx69b6673576ec5a65', // 滴滴出行服务号	
          }
          const appid = appidMap[store.getters.productType || 'didi']
          const state = Date.now().toString()
          window.sessionStorage.setItem('wxOauth', state)
          window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
            window.location.href.split('#')[0]
          )}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`)
          return Promise.reject({})
        }

        if (xenv() === 'gaswxmp') {
          weixinmpReady(() => {
            window.wx.miniProgram.redirectTo({
              url: build('/webx-mp/transfer-station/index?type=login', {
                back_url: build(window.location.href, option.redirectParams).split('#')[0],
              }),
            })
          })
          return Promise.reject()
        } else if (is('miniprogram')) {
          login({
            back_url: build(window.location.href.split('#')[0], option.redirectParams),
          })
          return Promise.reject()
        } else {
          return login({
            back_url: build(window.location.href.split('#')[0], option.redirectParams),
          })
        }
      } else {
        return login().then(res => {
          // 兼容webx-js-sdk失败依旧会返回成功的bug
          return res?.token ? Promise.resolve(res) : Promise.reject(res)
        })
      }
    }
    return Promise.resolve({})
  }).then(res => {
    setOmegaAttrs({
      uid: res.uid,
      token: res.token,
    })
    store.commit('setUserInfo', res)
    trackEventLogin()
    return Promise.resolve(res)
  })
}

export async function initLocation(onlyCityId) {
  if (__mpx_mode__ === 'web') {
    const QUERY = store.getters.query
    if (xenv() === 'mqq') {
      return Promise.reject()
    }

    if (is('miniprogram') && QUERY.cityid && QUERY.cityid !== '0') {
      setLocateSuccess({
        city_id: QUERY.cityid,
        cityId: QUERY.cityid,
      })
      if (onlyCityId) {
        return
      }
    }
  }
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject('timeout')
    }, 6000)
    getLocation().then(res => {
      setLocateSuccess(res)
      resolve(res)
    }).catch(e => {
      console.log('initLocation catch', e)
      reject(e)
    }).finally(() => {
      clearTimeout(timer)
    })
  })
}

function setLocateSuccess(res) {
  store.commit('setCityInfo', res)
  res.cityId && setOmegaAttrs({
    city_id: res.cityId
  })
  trackEventLocate()
}

// 在init请求 和 登陆完成之后发送，保证埋点有正确的xid和xak
export function trackEventLogin() {
  const { userInfo, initData, trackInfo } = store.getters
  if (trackInfo.hasTrackLogin) {
    return
  }
  if (!userInfo.token || !Object.keys(initData).length) {
    return
  }
  trackEvent('userteam_fx_home_auth_login_succ_bt', '登陆授权成功')
  store.commit('setTrackInfo', { ...trackInfo, hasTrackLogin: false })
}

export function trackEventLocate() {
  const { cityInfo, initData, trackInfo } = store.getters
  if (trackInfo.hasTrackLocate) {
    return
  }
  if ((!cityInfo.cityId && !cityInfo.lng && !cityInfo.lat) || !Object.keys(initData).length) {
    return
  }
  trackEvent('userteam_fx_home_auth_location_succ_bt', '地理位置授权成功')
  store.commit('setTrackInfo', { ...trackInfo ,hasTrackLocate: false })
}

export function getLocation() {
  return locate().then(option => {
    return new Promise(resolve => {
      const cityId = option.cityId || option.city_id
      if (cityId) {
        const res = {
          city_id: cityId,
          cityId: cityId,
          lat: option.lat,
          lng: option.lng,
        }
        store.commit('setCityInfo', res)
        return resolve(res)
      }
      getCityInfo(option, res => {
        if (res.errno === 0) {
          store.commit('setCityInfo', { cityId: res.cityId })
          setOmegaAttrs({ city_id: res.cityId })
        }
      })
      const res = {
        lat: option.lat,
        lng: option.lng,
      }
      resolve(res)
    })
  })
}

function getCityInfo(opts, cb) {
  let api = 'https://common.diditaxi.com.cn/webcore/geo/reversegeotop'
  let lat = opts.latitude || opts.lat
  let lng = opts.longitude || opts.lng
  let data = {
    from_lat: lat || -1,
    from_lng: lng || -1
  }
  get(api, {
    params: data,
    needSign: true
  }).then(
    function (res) {
      if (res.errno === 0) {
        cb({
          errno: 0,
          errmsg: 'ok',
          cityId: res.data.cityid,
          lat: lat,
          lng: lng
        })
      } else {
        cb({
          errno: -1,
          errmsg: '接口返回错误errno' + res.errno,
          cityId: null,
          lat: lat,
          lng: lng
        })
      }
    },
    function () {
      cb({
        errno: -1,
        errmsg: 'ajax error',
        cityId: null,
        lat: lat,
        lng: lng
      })
    }
  )
}

export function formatValue(val) {
  const [integer, decimal] = String(val || '').split('.')
  return {
    integer: integer || '',
    decimal: decimal || '',
    point: decimal ? '.' : ''
  }
}

const typeMap = {
  1: '立享',
  3: '立享',
  100: '立享',
}
export function getCouponTip(type) {
  return typeMap[type]
}

const couponTypeMap = {
  1: '满减券',
  3: '立减券',
  100: '折扣券',
}
export function getCouponTypeTip(type) {
  return couponTypeMap[type]
}

export function preloadImage(url, delay = 0, toWebp = true) {
  if (!Array.isArray(url)) url = [url]
  if (toWebp) {
    url = url.map(item => utils.webpUrl(item))
  }
  setTimeout(() => {
    new utils.LoadImgs(url, {
      timeout: 2000,
      ignoreError: true,
    }).start()
  }, delay)
}

export function formatPageConfig(pageConfig, template) {
  pageStyle[template] && preloadImage(utils.webpUrl(pageStyle[template].couponBg))
  if (pageConfig.index?.style) {
    pageConfig.index.style.backgroundImage && (pageConfig.index.style.backgroundImage = utils.webpUrl(pageConfig.index.style.backgroundImage))
  }
  // 老活动默认值
  if (!pageConfig.index?.style?.backgroundImage && pageStyle[template].indexStyle) {
    pageConfig.index.style = pageStyle[template].indexStyle
  }
  if (pageConfig.header) {
    pageConfig.header.image && (pageConfig.header.image = utils.webpUrl(pageConfig.header.image, {
      isImageTag: true
    }))
    pageConfig.header.image2 = utils.webpUrl(pageConfig.header.image2 || pageStyle[template].headerImage, {
      isImageTag: true
    })
  }
  Array.isArray(pageConfig.imageList) && pageConfig.imageList.forEach(item => {
    item.image = utils.webpUrl(item.image, {
      isImageTag: true
    })
  })
}

export function setTitle(title) {
  if (title === undefined || title === null) return
  if (__mpx_mode__ === 'web') {
    if (title.trim() === '') {
      title = '\u200E'
    }
    if (is('passenger,kfpassenger')) {
      bridge.setTitle({
        navi_title: title,
      })
    } else {
      window.document.title = title
    }
  } else {
    mpx.setNavigationBarTitle({
      title
    })
  }
}

export function getQuery() {
  const QUERY = store.getters.query
  return {
    dsi: QUERY.dsi,
    dchn: QUERY.dchn,
    source_id: QUERY.source_id,
    token: '__token__'
  }
}

export const shareConfig = {
  wyc: {
    title: '你的好友@你，并送你一张打车券',
    icon: 'https://ut-static.udache.com/webx/ut/TuG4LusgaQPpwz-ac0vLs.png',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/TuG4LusgaQPpwz-ac0vLs.png',
    webxPath: '/pages/index/index',
    webxUrl: 'https://v.didi.cn',
  },
  hy: {
    title: '货运福利免费领，省钱更省心！',
    icon: 'https://ut-static.udache.com/webx/ut/UOJP1mcqUo-YHCkshOcyj.png',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/UOJP1mcqUo-YHCkshOcyj.png',
    webxPath: '/pages/index/index',
    webxUrl: 'https://v.didi.cn',
  },
  ny: {
    title: '滴滴加油@你，领券加油更省钱！',
    icon: 'https://ut-static.udache.com/webx/ut/kfgfVGXDducqtNf6l7Bry.jpg',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/kfgfVGXDducqtNf6l7Bry.jpg',
    webxPath: '/pages/router/index',
    webxUrl: 'https://v.didi.cn',
  },
  hxz: {
    title: '打车想省钱？快来领花小猪优惠券',
    icon: 'https://ut-static.udache.com/webx/ut/ij-lIHflEw8GwhF1h_6HK.png',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/ij-lIHflEw8GwhF1h_6HK.png',
    webxPath: '/pages/chitu/index',
    webxUrl: 'https://v.didi.cn',
  },
  dj: {
    title: '你的好友@你，送你代驾大礼包',
    icon: 'https://ut-static.udache.com/webx/ut/yxf5mffioIYSwpEkWh0GY.jpg',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/yxf5mffioIYSwpEkWh0GY.jpg',
    webxPath: '/pages/index/index',
    webxUrl: 'https://v.didi.cn',
  },
  cz: {
    title: '你的好友@你，送你车主大礼包',
    icon: 'https://ut-static.udache.com/webx/ut/ppmJ_MjwNC6gJ0wd5DoaI.jpg',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/ppmJ_MjwNC6gJ0wd5DoaI.jpg',
    webxPath: '/pages/index/index',
    webxUrl: 'https://v.didi.cn',
  },
  zc: {
    title: '你的好友@你，并送你一张租车券',
    icon: 'https://ut-static.udache.com/webx/ut/fCldHhQOiveD1YgBh4eBi.png',
    shareCardImage: 'https://ut-static.udache.com/webx/ut/fCldHhQOiveD1YgBh4eBi.png',
    webxPath: '/pages/index/index',
    webxUrl: 'https://v.didi.cn',
  },
}

export function setShareForWebx(shareInfo, info) {
  if (!shareInfo?.channels?.wx_appmsg?.[0]) {
    return
  }
  const shareInfoWx = shareInfo.channels.wx_appmsg[0]
  if (__mpx_mode__ === 'web') {
    if (!canIUse('setShare')) {
      return
    }
    shareInfo.channels.wx_appmsg.push({
      ...shareInfoWx,
      xenv: 'passenger'
    })
    webxSetShare(shareInfo)
  } else {
    return {
      title: shareInfo.card_content,
      path: shareInfoWx.path,
      imageUrl: shareInfo.img_url
    }
  }
}

export function setShare(info) {
  const config = shareConfig[info.template]
  if (!canIUse('setShare') || !config) {
    return
  }
  const params = getQuery()
  const path = build(config.webxPath, params)
  const url = build(`${config.webxUrl}/${params.dchn}`, {
    dsi: params.dsi,
    source_id: params.source_id
  })
  webxSetShare({
    title: config.title,
    desc: '',
    icon: config.icon,
    card_content: config.title,
    img_url: config.shareCardImage,
    channels: {
      wx_timeline: [
        {
          xenv: 'weixin',
          share_type: 'text',
          link: url
        }
      ],
      wx_appmsg: [{
        xenv: 'gaswxmp',
        share_type: 'miniApp',
        path: path,
        appid: 'gh_aa7619f8455b',
      },
      {
        xenv: 'wxmp',
        share_type: 'miniApp',
        path: path,
        appid: 'gh_7a5c4141778f',
      },
      {
        xenv: 'kfwxmp',
        share_type: 'miniApp',
        path: path,
        appid: 'gh_6617da09780d',
      },
      {
        xenv: 'weixin',
        share_type: 'text',
        link: url
      },
      ],
    }
  })
}

export const gotoLink = utils.debounce(
  function (link, xspmInfo) {
    if (!link) return
    link = link.trim()
    goTo({
      url: link,
      extParams: {
        xspmInfo,
        noCompileDchn: __mpx_mode__ === 'web' && !is('miniprogram'), // 小程序和端 需要解析dchn
      },
    })
  },
  500,
  true
)

export const chapter = {
  wyc: {
    toUseBtn: 'c831',
    popupToUseBtn: 'c832',
    couponToUseBtn: 'c841',
  },
  hy: {
    toUseBtn: 'c835',
    popupToUseBtn: 'c836',
    couponToUseBtn: 'c843',
  },
  ny: {
    toUseBtn: 'c833',
    popupToUseBtn: 'c834',
    couponToUseBtn: 'c842',
  },
  hxz: {
    toUseBtn: 'c837',
    popupToUseBtn: 'c838',
    couponToUseBtn: 'c844',
  },
  dj: {
    toUseBtn: 'c839',
    popupToUseBtn: 'c840',
    couponToUseBtn: 'c845',
  },
  cz: {
    toDj: 'c939',
    toNy: 'c938',
  },
  zc: {
    toUseBtn: 'c1508',
  },
  gift: {
    couponToUseBtn: 'c1995',
    toUseBtn: 'c1994',
  }
}

export async function getEnvParams(e) {
  const envInfo = await getEnvInfo({
    forceLocate: false,
  })
  store.getters.cityInfo.cityId &&
    (envInfo.cityId = String(store.getters.cityInfo.cityId))
  return {
    ...envInfo,
    isOpenWeb: __mpx_mode__ === 'web', // 小猪其他业务可能会把envInfo设置为string类型，导致后端报错
    isHitButton: true,
    xAxes: String(e?.detail?.x || ''),
    yAxes: String(e?.detail?.y || ''),
  }
}
